import { OctopusLogo } from '@lib/components'
import type React from 'react'

import css from './styles.module.css'

// todo: make global loader
export const DashboardLoader: React.FC = () => (
  <div className={css.dashboard_loader}>
    <OctopusLogo className={css.dashboard_loader_image} />
  </div>
)
